import React from 'react';
import { useSelector, useDispatch, shallowEqual } from 'react-redux';
import styles from './styles/styles.module.scss';
import FeedRiver from '../FeedRiver';
import RiverMore from '../cards/RiverMore';
import useUserConnections from '../../hooks/useUserConnections';
import UserSuggestionCard from '../cards/suggestionCards/UserSuggestionCard';
import FacebookSuggestionCard from '../cards/suggestionCards/FacebookSuggestionCard';
import ContactsSuggestionCard from '../cards/suggestionCards/ContactsSuggestionCard';
import Fade from '../../../../components/animations/Fade';
import { StringConstantsMixin } from '../../../../application/javascripts/react_components/mixins/shared/string_constants_mixin';
import { SUGGESTED_FACEBOOK, SUGGESTED_CONTACTS, SUGGESTED_MORE, SUGGESTIONS_MODAL, FACEBOOK_NOT_SUBMITTED } from '../../constants';
import { dismissUser } from '../../ducks/suggestedUserConnections';
import { setActiveModal } from '../../ducks/modals';

const {
  strings: {
    COMMUNITY: { SUGGESTED_MEMBERS }
  }
} = StringConstantsMixin;
const SHOW_MORE_LIMIT = 8;

const SuggestedUserConnectionsRiver = () => {
  const dispatch = useDispatch();
  const {
    belay: {
      facebook: { facebookStatus }
    }
  } = useSelector(state => state, shallowEqual);
  const userConnections = useUserConnections('suggestedUserConnections');

  const getSuggestedUserConnections = () => {
    let suggestedUserConnections = [...userConnections];
    if (suggestedUserConnections.length >= SHOW_MORE_LIMIT) {
      suggestedUserConnections = suggestedUserConnections.slice(0, SHOW_MORE_LIMIT);
      suggestedUserConnections.push({ type: SUGGESTED_MORE });
    } else {
      if (facebookStatus === FACEBOOK_NOT_SUBMITTED) {
        // if facebook is not connected
        suggestedUserConnections.push({ type: SUGGESTED_FACEBOOK });
      }

      if (true) {
        // if contacts are not connected
        suggestedUserConnections.push({ type: SUGGESTED_CONTACTS });
      }
    }
    return suggestedUserConnections;
  };

  const suggestedUserConnections = getSuggestedUserConnections();

  const handleDismiss = idx => {
    dispatch(dismissUser(idx));
  };

  return (
    <div className={styles.container}>
      <div className={styles.title}>{SUGGESTED_MEMBERS}</div>
      <FeedRiver childClassName={styles.riverChildClass} centerMode={false}>
        {suggestedUserConnections.map((suggestion, idx) => {
          switch (suggestion.type) {
            case SUGGESTED_FACEBOOK:
              return <FacebookSuggestionCard key="facebookSuggestionCard" />;
            case SUGGESTED_CONTACTS:
              return <ContactsSuggestionCard key="contactsSuggestionCard" />;
            case SUGGESTED_MORE:
              return <RiverMore onClick={() => dispatch(setActiveModal(SUGGESTIONS_MODAL))} />;
            default:
              return (
                <Fade key={suggestion.user.id} onExitDone={() => handleDismiss(idx)} fadeOutOnly>
                  {(animationStyles, onTransitionEnd, unMount) => (
                    <span onTransitionEnd={onTransitionEnd} className={`${animationStyles}`}>
                      <UserSuggestionCard userConnection={suggestion} onClearClick={unMount} />
                    </span>
                  )}
                </Fade>
              );
          }
        })}
      </FeedRiver>
    </div>
  );
};

export default SuggestedUserConnectionsRiver;
